"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _styles = require("../styles");
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["children", "title", "wrapper", "wrapperProps", "arrow", "placement", "wrapperZeroMinWidth", "inlineWrapper", "noMaxWidth", "classes", "wrapperComponent", "extremelyLongTitle"];
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    root: {},
    noMaxWidth: {
      maxWidth: 'none'
    }
  }, {
    name: 'GgTooltip'
  };
});
var ExtremelyLongTitleWrapper = (0, _styles.styled)('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  max-height: 50vh;\n  overflow-y: auto;\n"])));
var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$wrapper = _ref.wrapper,
    wrapper = _ref$wrapper === void 0 ? false : _ref$wrapper,
    _ref$wrapperProps = _ref.wrapperProps,
    wrapperProps = _ref$wrapperProps === void 0 ? {} : _ref$wrapperProps,
    _ref$arrow = _ref.arrow,
    arrow = _ref$arrow === void 0 ? true : _ref$arrow,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'top-start' : _ref$placement,
    _ref$wrapperZeroMinWi = _ref.wrapperZeroMinWidth,
    wrapperZeroMinWidth = _ref$wrapperZeroMinWi === void 0 ? false : _ref$wrapperZeroMinWi,
    inlineWrapper = _ref.inlineWrapper,
    _ref$noMaxWidth = _ref.noMaxWidth,
    noMaxWidth = _ref$noMaxWidth === void 0 ? false : _ref$noMaxWidth,
    classes = _ref.classes,
    _ref$wrapperComponent = _ref.wrapperComponent,
    wrapperComponent = _ref$wrapperComponent === void 0 ? 'span' : _ref$wrapperComponent,
    _ref$extremelyLongTit = _ref.extremelyLongTitle,
    extremelyLongTitle = _ref$extremelyLongTit === void 0 ? false : _ref$extremelyLongTit,
    props = _objectWithoutProperties(_ref, _excluded);
  var tooltipClasses = useStyles();
  var content = wrapper ? /*#__PURE__*/(0, _react.createElement)(wrapperComponent, _objectSpread(_objectSpread({}, wrapperProps), {}, {
    style: _objectSpread(_objectSpread({
      textDecoration: 'inherit'
    }, wrapperZeroMinWidth ? {
      minWidth: 0
    } : {}), wrapperProps === null || wrapperProps === void 0 ? void 0 : wrapperProps.style),
    'data-cy': 'TooltipWrapper'
  }), children) : children;
  if (!title) {
    return content;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip["default"], _objectSpread(_objectSpread({
    title: extremelyLongTitle ? /*#__PURE__*/(0, _jsxRuntime.jsx)(ExtremelyLongTitleWrapper, {
      children: title
    }) : title,
    arrow: arrow
  }, props), {}, {
    placement: placement,
    classes: _objectSpread(_objectSpread({}, classes), {}, {
      tooltip: (0, _clsx2["default"])(classes === null || classes === void 0 ? void 0 : classes.tooltip, tooltipClasses.root, _defineProperty({}, tooltipClasses.noMaxWidth, noMaxWidth))
    }),
    children: content
  }));
};
var _default = exports["default"] = Tooltip;